// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-control {
  display: block;
  width: 100%;
  padding: 7px 11px;
  border-radius: 4px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  width: 100%;
  height: 36px;
  appearance: none;
  resize: none;
}
.input-control::placeholder {
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  opacity: 0.7;
}
.input-control:focus {
  border: 1px solid #84ADFF;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #EFF4FF;
}
.input-control:active {
  border: 1px solid #84ADFF;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #EFF4FF;
}
.input-control:disabled {
  border: 1px solid var(--AA-gloabl-border);
  background: #F9FAFB;
  pointer-events: none;
  cursor: not-allowed;
}
.input-control.error {
  border: 1px solid #FDA29B;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #FEE4E2;
}

textarea.input-control {
  min-height: 70px;
}

.sugestions-block {
  border-radius: 4px;
  border: 1px solid var(--borderSuggestions);
  background: var(--AA-global-white-bg);
  display: flex;
  flex-direction: column;
}
.sugestions-block .suggestion-header {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  min-height: 32px;
  gap: 5px;
  width: 100%;
  overflow: hidden;
  position: relative;
}
.sugestions-block .suggestion-header .icon_block {
  flex-shrink: 0;
  line-height: 0;
}
.sugestions-block .suggestion-header h1 {
  max-width: 100%;
}
.sugestions-block .suggestion-header .count-text {
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  padding: 0px 8px;
  height: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--AA-global-theme-text-color);
}
.sugestions-block .suggestion-header .by-n-ai {
  display: flex;
  align-items: center;
  color: var(--AA-gloabl-text-desc-color);
  gap: 2px;
}
.sugestions-block .suggestion-header .by-n-ai svg {
  opacity: 0.5;
  width: 14px;
  height: 14px;
}
.sugestions-block .suggestion-header .by-n-ai svg path {
  fill: var(--AA-gloabl-text-color);
}
.sugestions-block .suggestion-header .by-n-ai i {
  opacity: 0.5;
}
.sugestions-block .suggestion-header .by-n-ai .snippet-by-label {
  color: var(--AA-gloabl-text-desc-color);
  font-style: italic;
}
.sugestions-block .suggestion-body-search {
  padding: 0px 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.sugestions-block .suggestion-body-search .suggestion-item-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 8px 0;
  position: relative;
}
.sugestions-block .suggestion-body-search .suggestion-item-card:hover {
  transition: 0.2s all ease;
}
.sugestions-block .suggestion-body-search .suggestion-item-card:hover .suggestion-header-faq .action-buttons {
  display: flex;
}
.sugestions-block .suggestion-body-search .suggestion-item-card.hidden {
  display: none;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
  transition: 0.2s all ease;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .sent-msg-text {
  color: var(--AA-global-theme-text-color);
  margin: 0 0 0 auto;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .up-down-arrows {
  flex-shrink: 0;
  cursor: pointer;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .up-down-arrows svg {
  height: 14px;
  width: 14px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .titles-info-sec .up-down-arrows svg path {
  fill: var(--AA-gloabl-text-color);
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .action-buttons {
  flex-shrink: 0;
  display: none;
  align-items: center;
  gap: 4px;
  position: absolute;
  right: 0;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .action-buttons .aa-copy-btn-suggestion svg path {
  stroke: var(--AA-gloabl-text-color);
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-header-faq .action-buttons .aa-solidbtn {
  height: 24px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  transition: 0.2s all ease;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph {
  transition: max-height 0.3s ease;
  overflow: hidden;
  max-height: 50px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph.expanded {
  max-height: none; /* Show full content when expanded */
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph.expanded + .aa-more-button {
  display: none; /* Hide button when expanded */
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .suggestion-paragraph:not(.expanded) + .aa-more-button {
  display: block; /* Show button when not expanded */
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq:hover .action-buttons {
  display: flex;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .action-buttons {
  flex-shrink: 0;
  display: none;
  align-items: center;
  gap: 4px;
  position: absolute;
  right: 0;
  z-index: 1;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .action-buttons .aa-solidbtn {
  height: 24px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .more-links-buttons {
  display: flex;
  align-items: center;
  gap: 4px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .line-with-text-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin: 6px 0;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .line-with-text-heading h2 {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
  flex-shrink: 0;
  color: #F04438;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .line-with-text-heading span {
  width: 100%;
  height: 1px;
  background: var(--AA-gloabl-border);
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 4px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper h1 {
  font-style: italic;
  flex-shrink: 0;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  overflow: hidden;
  flex-wrap: wrap;
  width: 100%;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag {
  display: flex;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  transition: 0.2s all ease;
  flex: 0 auto;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag:hover span {
  opacity: 1;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag:hover a {
  text-decoration-line: underline;
  opacity: 1;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag span {
  display: flex;
  width: 14px;
  height: 14px;
  padding: 0;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 16px;
  background: var(--AA-global-white-bg);
  color: var(--AA-gloabl-text-color);
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .suggestion-body-faq .souces-names-wrapper .source-names .source-tag a {
  overflow: hidden;
  color: var(--AA-gloabl-text-desc-color);
  text-align: center;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  opacity: 0.8;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info {
  padding: 0;
  background: transparent;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info .dialog-ended-and-feedback {
  justify-content: flex-end;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info .icon_block {
  display: none;
}
.sugestions-block .suggestion-body-search .suggestion-item-card .form-feedback-info .dialog-ended-and-feedback .feedback-wrapper .feedback-actions-info .left-sec-info h1 {
  display: none;
}
.sugestions-block .suggestion-body-search .less-text.hidden {
  display: none;
}
.sugestions-block .suggestion-body-search .more-text.hidden {
  display: none;
}

.search-block-data-suggestions-wrapper {
  height: 100%;
  padding: 8px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-radius: 4px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .empty-search-container-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 277px;
  margin: 0 auto;
  gap: 10px;
  flex-direction: column;
  height: 100%;
  text-align: center;
  min-height: 300px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .suggestionslist-conntent-search {
  flex: 1 1 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 4px;
  position: relative;
  height: 100%;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .suggestionslist-conntent-search .suggestionslist-conntent-scroll {
  padding: 8px 12px 0px 12px;
  overflow: auto;
  height: 100%;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .suggestionslist-conntent-search .search-app-dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .suggestionslist-conntent-search .search-app-dialog-content .search-header-content {
  display: flex;
  align-items: center;
  padding: 8px;
  min-height: 36px;
  gap: 10px;
  border-bottom: 1px solid var(--AA-gloabl-border);
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .suggestionslist-conntent-search .search-app-dialog-content .search-header-content svg path {
  fill: var(--AA-global-theme-text-color);
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .suggestionslist-conntent-search .search-app-dialog-content .search-all-dialog-content {
  flex: 1 1 auto;
  overflow: auto;
  position: relative;
  padding: 10px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input {
  padding: 8px 12px;
  flex-shrink: 0;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .suggestions-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 8px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .suggestions-info button {
  position: relative;
  padding: 2px 10px;
  border-radius: 16px;
  background: var(--AA-gloabl-bg-secondary);
  color: var(--AA-gloabl-text-color);
  border: 0;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .suggestions-info p {
  font-style: italic;
  margin: 0;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block {
  position: relative;
  background: var(--AA-global-white-bg);
  border-radius: 8px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .input-control {
  z-index: 1;
  position: relative;
  background: transparent;
  padding-right: 35px;
  padding-left: 35px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .input-control.suggestion-input {
  display: block;
  width: 100%;
  color: var(--AA-gloabl-text-color);
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .input-control.suggestion-input::-moz-selection { /* Code for Firefox */
  color: var(--AA-gloabl-text-color);
  background: transparent;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .input-control.suggestion-input::selection {
  color: var(--AA-gloabl-text-color);
  background: transparent;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .input-control.auto-expand-textarea {
  resize: none;
  overflow: hidden;
  min-height: 32px;
  max-height: 120px;
  line-height: 1.4;
  word-wrap: break-word;
  white-space: pre-wrap;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .input-control.auto-expand-textarea:focus {
  overflow-y: auto;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block svg {
  cursor: pointer;
  position: absolute;
  left: 12px;
  top: 10px;
  z-index: 2;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block svg path {
  fill: var(--AA-gloabl-text-color);
  opacity: 0.5;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block:has(.auto-expand-textarea) svg {
  top: 8px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block:has(.auto-expand-textarea) .clear-search {
  top: 10px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .clear-search {
  position: absolute;
  right: 12px;
  top: 8px;
  z-index: 2;
  cursor: pointer;
  background: border-box;
  border: 0;
  padding: 0;
  font-size: 16px;
  line-height: 0;
  color: var(--AA-gloabl-text-color);
  width: 16px;
  height: 16px;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .clear-search svg {
  position: initial;
}
.search-block-data-suggestions-wrapper .search-block-data-suggestions .search-block-input .input-block .clear-search svg path {
  stroke: var(--AA-gloabl-text-color);
}

.dialog-search-cards-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
}

.dialog-search-card {
  padding: 4px 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.dialog-search-card p {
  width: 100%;
}
.dialog-search-card .aa-run-btn, .dialog-search-card .aa-agent-run-btn {
  flex-shrink: 0;
}

.highlight-dialog:hover {
  cursor: pointer;
  background-color: var(--AA-static-border);
}
.highlight-dialog:hover .aa-text-xs {
  color: var(--AA-primary-color);
}

.aa-run-btn {
  flex-shrink: 0;
  border-radius: 3px;
  background: var(--AA-global-theme-bg);
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 5px 10px;
  border: 0;
  color: var(--AA-global-white-color);
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
}

.aa-agent-run-btn {
  border: 1px solid var(--AA-global-theme-bg);
  border-radius: 4px;
  background: transparent;
  width: 24px;
  padding: 0;
  cursor: pointer;
  color: var(--AA-global-theme-text-color);
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.aa-agent-run-btn svg path {
  fill: var(--AA-global-theme-text-color);
}`, "",{"version":3,"sources":["webpack://./src/scss/_formControls.scss","webpack://./src/components/common/templatemanager/tabs/search/search.scss","webpack://./src/scss/_search_suggestion.scss"],"names":[],"mappings":"AACA;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;ACAJ;ADCI;EACI,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;ACCR;ADCI;EACI,yBAAA;EACA,2EAAA;ACCR;ADCI;EACI,yBAAA;EACA,2EAAA;ACCR;ADCI;EACI,yCAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;ACCR;ADCI;EACI,yBAAA;EACA,2EAAA;ACCR;;ADII;EACE,gBAAA;ACDN;;ACxCA;EACI,kBAAA;EACA,0CAAA;EACA,qCAAA;EACA,aAAA;EACA,sBAAA;AD2CJ;AC1CI;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AD4CR;AC3CQ;EACI,cAAA;EACA,cAAA;AD6CZ;AC3CQ;EACI,eAAA;AD6CZ;AC3CQ;EACI,cAAA;EACA,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;AD6CZ;AC3CQ;EACI,aAAA;EACA,mBAAA;EACA,uCAAA;EACA,QAAA;AD6CZ;AC5CY;EACI,YAAA;EACA,WAAA;EACA,YAAA;AD8ChB;AC7CgB;EACI,iCAAA;AD+CpB;AC5CY;EACI,YAAA;AD8ChB;AC5CY;EACI,uCAAA;EACA,kBAAA;AD8ChB;AC1CI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AD4CR;AC3CQ;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AD6CZ;AC5CY;EACI,yBAAA;AD8ChB;AC5CoB;EACI,aAAA;AD8CxB;AC1CY;EACI,aAAA;AD4ChB;AC1CY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;AD4ChB;AC3CgB;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AD6CpB;AC5CoB;EACI,wCAAA;EACA,kBAAA;AD8CxB;ACzCoB;EACI,cAAA;EACA,eAAA;AD2CxB;AC1CwB;EACI,YAAA;EACA,WAAA;AD4C5B;AC3C4B;EACI,iCAAA;AD6ChC;ACrCgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;ADuCpB;ACpC4B;EACI,mCAAA;ADsChC;AClCoB;EACI,YAAA;ADoCxB;AChCY;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;ADkChB;ACjCgB;EACI,gCAAA;EACA,gBAAA;EACA,gBAAA;ADmCpB;ACjCgB;EACI,gBAAA,EAAA,oCAAA;ADmCpB;ACjCgB;EACI,aAAA,EAAA,8BAAA;ADmCpB;AChCgB;EACI,cAAA,EAAA,kCAAA;ADkCpB;AC/BoB;EACI,aAAA;ADiCxB;AC9BgB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;ADgCpB;AC/BoB;EACI,YAAA;ADiCxB;AC9BgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;ADgCpB;AC9BgB;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;ADgCpB;AC/BoB;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,cAAA;ADiCxB;AC/BoB;EACI,WAAA;EACA,WAAA;EACA,mCAAA;ADiCxB;AC9BgB;EACI,aAAA;EACA,uBAAA;EACA,QAAA;ADgCpB;AC/BoB;EACI,kBAAA;EACA,cAAA;ADiCxB;AC/BoB;EACI,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;ADiCxB;AChCwB;EACI,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,yCAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;ADkC5B;AChCgC;EACI,UAAA;ADkCpC;AChCgC;EACI,+BAAA;EACA,UAAA;ADkCpC;AC/B4B;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,qCAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ADiChC;AC/B4B;EACI,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;ADiChC;AC3BY;EACI,UAAA;EACA,uBAAA;AD6BhB;AC5BgB;EACI,yBAAA;AD8BpB;AC1BgC;EACI,aAAA;AD4BpC;AC1BgC;EACI,aAAA;AD4BpC;ACnBY;EACI,aAAA;ADqBhB;ACjBY;EACI,aAAA;ADmBhB;;AAjTA;EACI,YAAA;EACA,YAAA;AAoTJ;AAnTI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yCAAA;EACA,qCAAA;AAqTR;AApTQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAsTZ;AApTQ;EACI,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AAsTZ;AArTY;EACI,0BAAA;EACA,cAAA;EACA,YAAA;AAuThB;AArTY;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AAuThB;AAtTgB;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;EACA,gDAAA;AAwTpB;AAtTwB;EACI,uCAAA;AAwT5B;AApTgB;EACI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;AAsTpB;AAlTQ;EACI,iBAAA;EACA,cAAA;AAoTZ;AAnTY;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;AAqThB;AApTgB;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yCAAA;EACA,kCAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAsTpB;AApTgB;EACI,kBAAA;EACA,SAAA;AAsTpB;AAnTY;EACI,kBAAA;EACA,qCAAA;EACA,kBAAA;AAqThB;AApTgB;EACI,UAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAsTpB;AAnToB;EACI,cAAA;EACA,WAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAqTxB;AApTwB,yJAAA,qBAAA;EACI,kCAAA;EACA,uBAAA;AAsT5B;AApTwB;EACI,kCAAA;EACA,uBAAA;AAsT5B;AAlToB;EACI,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qBAAA;AAoTxB;AAlTwB;EACI,gBAAA;AAoT5B;AAhTgB;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAkTpB;AAjToB;EACI,iCAAA;EACA,YAAA;AAmTxB;AA9SoB;EACI,QAAA;AAgTxB;AA9SoB;EACI,SAAA;AAgTxB;AA7SgB;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;AA+SpB;AA9SoB;EACI,iBAAA;AAgTxB;AA/SwB;EACI,mCAAA;AAiT5B;;AAtSA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AAySJ;;AAtSA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAySJ;AAxSI;EACI,WAAA;AA0SR;AAxSI;EACI,cAAA;AA0SR;;AAtSA;EACI,eAAA;EACA,yCAAA;AAySJ;AAxSI;EACI,8BAAA;AA0SR;;AAtSA;EACI,cAAA;EACA,kBAAA;EACA,qCAAA;EACA,+CAAA;EACA,iBAAA;EACA,SAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAySJ;;AAvSA;EACI,2CAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,UAAA;EACA,eAAA;EACA,wCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA0SJ;AAxSQ;EACI,uCAAA;AA0SZ","sourcesContent":["\n.input-control{\n    display: block;\n    width: 100%;\n    padding: 7px 11px;\n    border-radius: 4px;\n    border: 1px solid var(--AA-gloabl-border);\n    background: var(--AA-global-white-bg);\n    width: 100%;\n    height: 36px;\n    appearance: none;\n    resize: none;\n    &::placeholder{\n        color: var(--AA-gloabl-text-color); \n        font-size: 12px;\n        font-weight: 400;\n        line-height: 20px;\n        opacity: 0.7;\n    }\n    &:focus{\n        border: 1px solid #84ADFF;\n        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #EFF4FF;\n    }\n    &:active{\n        border: 1px solid #84ADFF;\n        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #EFF4FF;\n    }\n    &:disabled{\n        border: 1px solid var(--AA-gloabl-border);\n        background: #F9FAFB;\n        pointer-events: none;\n        cursor: not-allowed;\n    }\n    &.error{\n        border: 1px solid #FDA29B;\n        box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #FEE4E2;\n    }\n}\n\ntextarea {\n    &.input-control {\n      min-height: 70px;\n    }\n}","@import './../../../../../scss/formControls';\n@import './../../../../../scss/search_suggestion';\n\n.search-block-data-suggestions-wrapper{\n    height: 100%;\n    padding: 8px;\n    .search-block-data-suggestions{\n        height: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: flex-end;\n        border-radius: 4px;\n        border: 1px solid var(--AA-gloabl-border);\n        background: var(--AA-global-white-bg);\n        .empty-search-container-wrapper{\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            width: 277px;\n            margin: 0 auto;\n            gap: 10px;\n            flex-direction: column;\n            height: 100%;\n            text-align: center;\n            min-height: 300px;\n        }\n        .suggestionslist-conntent-search{\n            flex: 1 1 auto;\n            overflow: hidden;\n            display: flex;\n            flex-direction: column;\n            gap: 4px;\n            position: relative;\n            height: 100%;\n            .suggestionslist-conntent-scroll{\n                padding: 8px 12px 0px 12px;\n                overflow: auto;\n                height: 100%;\n            }\n            .search-app-dialog-content{\n                height: 100%;\n                display: flex;\n                flex-direction: column;\n                width: 100%;\n                .search-header-content{\n                    display: flex;\n                    align-items: center;\n                    padding: 8px;\n                    min-height: 36px;\n                    gap: 10px;\n                    border-bottom: 1px solid var(--AA-gloabl-border);\n                    svg{\n                        path{\n                            fill: var(--AA-global-theme-text-color);\n                        }\n                    }\n                }\n                .search-all-dialog-content{\n                    flex: 1 1 auto;\n                    overflow: auto;\n                    position: relative;\n                    padding: 10px;\n                }\n            }\n        }\n        .search-block-input{\n            padding: 8px 12px;\n            flex-shrink: 0;\n            .suggestions-info{\n                display: flex;\n                align-items: center;\n                flex-wrap: wrap;\n                gap: 5px;\n                margin-bottom: 8px;\n                button{\n                    position: relative;\n                    padding: 2px 10px;\n                    border-radius: 16px;\n                    background: var(--AA-gloabl-bg-secondary);\n                    color: var(--AA-gloabl-text-color);\n                    border: 0;\n                    cursor: pointer;\n                    overflow: hidden;\n                    white-space: nowrap;\n                    text-overflow: ellipsis;\n                }\n                p{\n                    font-style: italic;\n                    margin: 0;\n                }\n            }\n            .input-block{\n                position: relative;\n                background: var(--AA-global-white-bg);\n                border-radius: 8px;\n                .input-control{\n                    z-index: 1;\n                    position: relative;\n                    background: transparent;\n                    padding-right: 35px;\n                    padding-left: 35px;\n\n                    \n                    &.suggestion-input{\n                        display: block;\n                        width: 100%;\n                        color: var(--AA-gloabl-text-color);\n                        background: transparent;\n                        position: absolute;\n                        top: 0;\n                        left: 0;\n                        z-index: 0;\n                        &::-moz-selection { /* Code for Firefox */\n                            color: var(--AA-gloabl-text-color);\n                            background: transparent;\n                        }                  \n                        &::selection {\n                            color: var(--AA-gloabl-text-color);\n                            background: transparent;\n                        }\n                    }\n\n                    &.auto-expand-textarea {\n                        resize: none;\n                        overflow: hidden;\n                        min-height: 32px;\n                        max-height: 120px;\n                        line-height: 1.4;\n                        word-wrap: break-word;\n                        white-space: pre-wrap;\n                        \n                        &:focus {\n                            overflow-y: auto;\n                        }\n                    }\n                }\n                svg{\n                    cursor: pointer;\n                    position: absolute;\n                    left: 12px;\n                    top: 10px;\n                    z-index: 2;\n                    path{\n                        fill: var(--AA-gloabl-text-color);\n                        opacity: 0.5;\n                    }\n                }\n\n                &:has(.auto-expand-textarea) {\n                    svg {\n                        top: 8px;\n                    }\n                    .clear-search {\n                        top: 10px;\n                    }\n                }\n                .clear-search{\n                    position: absolute;\n                    right: 12px;\n                    top: 8px;\n                    z-index: 2;\n                    cursor: pointer;\n                    background: border-box;\n                    border: 0;\n                    padding: 0;\n                    font-size: 16px;\n                    line-height: 0;\n                    color: var(--AA-gloabl-text-color);\n                    width: 16px;\n                    height: 16px;\n                    svg{\n                        position: initial;\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                \n            }\n        }\n    }\n}\n\n\n.dialog-search-cards-wrapper{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 4px;\n}\n\n.dialog-search-card{\n    padding: 4px 8px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    p{\n        width: 100%;\n    }\n    .aa-run-btn, .aa-agent-run-btn{\n        flex-shrink: 0;\n    }\n}\n\n.highlight-dialog:hover{\n    cursor: pointer;\n    background-color:var(--AA-static-border);\n    .aa-text-xs{\n        color: var(--AA-primary-color);\n    }\n}\n\n.aa-run-btn{\n    flex-shrink: 0;\n    border-radius: 3px;\n    background: var(--AA-global-theme-bg);\n    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.05);\n    padding: 5px 10px;\n    border: 0;\n    color: var(--AA-global-white-color);\n    font-size: 10px;\n    font-weight: 700;\n    cursor: pointer;\n}\n.aa-agent-run-btn{\n    border: 1px solid var(--AA-global-theme-bg);\n    border-radius: 4px;\n    background: transparent;\n    width: 24px;\n    padding: 0;\n    cursor: pointer;\n    color: var(--AA-global-theme-text-color);\n    height: 22px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    svg{\n        path{\n            fill: var(--AA-global-theme-text-color);\n        }\n    }\n}",".sugestions-block{\n    border-radius: 4px;\n    border: 1px solid var(--borderSuggestions);\n    background: var(--AA-global-white-bg);\n    display: flex;\n    flex-direction: column;\n    .suggestion-header{\n        display: flex;\n        align-items: center;\n        padding: 4px 8px;\n        min-height: 32px;\n        gap: 5px;\n        width: 100%;\n        overflow: hidden;\n        position: relative;\n        .icon_block{\n            flex-shrink: 0;\n            line-height: 0;\n        }\n        h1{\n            max-width: 100%;\n        }\n        .count-text{\n            flex-shrink: 0;\n            border-radius: 16px;\n            background: var(--AA-gloabl-bg-secondary);\n            padding: 0px 8px;\n            height: 15px;\n            display: flex;                   \n            justify-content: center;\n            align-items: center;\n            color: var(--AA-global-theme-text-color);\n        }\n        .by-n-ai{\n            display: flex;\n            align-items: center;\n            color: var(--AA-gloabl-text-desc-color);\n            gap: 2px;\n            svg{\n                opacity: 0.5;\n                width: 14px;\n                height: 14px;\n                path{\n                    fill: var(--AA-gloabl-text-color);\n                }\n            }\n            i{\n                opacity: 0.5;\n            }\n            .snippet-by-label{\n                color: var(--AA-gloabl-text-desc-color);\n                font-style: italic;\n            }\n        }\n    }\n    .suggestion-body-search{\n        padding: 0px 8px;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n        width: 100%;\n        .suggestion-item-card{\n            display: flex;\n            flex-direction: column;\n            gap: 8px;\n            width: 100%;\n            padding: 8px 0;\n            position: relative;\n            &:hover{\n                transition: 0.2s all ease;\n                .suggestion-header-faq{\n                    .action-buttons{\n                        display: flex;\n                    }\n                }\n            }\n            &.hidden {\n                display: none;\n            }\n            .suggestion-header-faq{\n                display: flex;\n                align-items: center;\n                gap: 10px;\n                position: relative;\n                transition: 0.2s all ease;\n                .titles-info-sec{\n                    width: 100%;\n                    display: flex;\n                    align-items: center;\n                    gap: 4px;\n                    overflow: hidden;\n                    .sent-msg-text{\n                        color: var(--AA-global-theme-text-color);\n                        margin: 0 0 0 auto;\n                    }\n                    .child-bot-name{\n                       \n                    }\n                    .up-down-arrows{\n                        flex-shrink: 0;\n                        cursor: pointer;\n                        svg{\n                            height: 14px;\n                            width: 14px;\n                            path{\n                                fill: var(--AA-gloabl-text-color);\n                            }\n                        }\n                        &.aa-faq-up-arrow{\n                            \n                        }\n                    }\n                }\n                .action-buttons{\n                    flex-shrink: 0;\n                    display: none;\n                    align-items: center;\n                    gap: 4px;\n                    position: absolute;\n                    right: 0;\n                    .aa-copy-btn-suggestion{\n                        svg{\n                            path{\n                                stroke: var(--AA-gloabl-text-color);\n                            }\n                        }\n                    }\n                    .aa-solidbtn{\n                        height: 24px;\n                    }\n                }\n            }\n            .suggestion-body-faq{\n                width: 100%;\n                display: flex;\n                flex-direction: column;\n                gap: 8px;\n                position: relative;\n                transition: 0.2s all ease;\n                .suggestion-paragraph{\n                    transition: max-height 0.3s ease; \n                    overflow: hidden;\n                    max-height: 50px;\n                }\n                .suggestion-paragraph.expanded {\n                    max-height: none; /* Show full content when expanded */\n                }\n                .suggestion-paragraph.expanded + .aa-more-button {\n                    display: none; /* Hide button when expanded */\n                }\n        \n                .suggestion-paragraph:not(.expanded) + .aa-more-button {\n                    display: block; /* Show button when not expanded */\n                }\n                &:hover{\n                    .action-buttons{\n                        display: flex;\n                    }\n                }\n                .action-buttons{\n                    flex-shrink: 0;\n                    display: none;\n                    align-items: center;\n                    gap: 4px;\n                    position: absolute;\n                    right: 0;\n                    z-index: 1;\n                    .aa-solidbtn{\n                        height: 24px;\n                    }\n                }\n                .more-links-buttons{\n                    display: flex;\n                    align-items: center;\n                    gap: 4px;\n                }\n                .line-with-text-heading{\n                    display: flex;\n                    align-items: center;\n                    gap: 6px;\n                    width: 100%;\n                    margin: 6px 0;\n                    h2{\n                        font-size: 12px;\n                        font-weight: 500;\n                        line-height: 18px;\n                        margin: 0;\n                        flex-shrink: 0;\n                        color: #F04438;\n                    }\n                    span{\n                        width: 100%;\n                        height: 1px;\n                        background: var(--AA-gloabl-border);\n                    }\n                }\n                .souces-names-wrapper{\n                    display: flex;\n                    align-items: flex-start;\n                    gap: 4px;\n                    h1{\n                        font-style: italic;\n                        flex-shrink: 0;\n                    }\n                    .source-names{\n                        display: flex;\n                        align-items: flex-start;\n                        gap: 8px;\n                        overflow: hidden;\n                        flex-wrap: wrap;\n                        width: 100%;\n                        .source-tag{\n                            display: flex;\n                            padding: 2px 8px;\n                            justify-content: center;\n                            align-items: center;\n                            gap: 4px;\n                            border-radius: 16px;\n                            background: var(--AA-gloabl-bg-secondary);\n                            transition: 0.2s all ease;\n                            flex : 0 auto;\n                            text-overflow: ellipsis;\n                            overflow: hidden;\n                            white-space: nowrap;\n                            &:hover{\n                                span{\n                                    opacity: 1;\n                                }\n                                a{\n                                    text-decoration-line: underline;\n                                    opacity: 1;\n                                }\n                            }\n                            span{\n                                display: flex;\n                                width: 14px;\n                                height: 14px;\n                                padding: 0;\n                                justify-content: center;\n                                align-items: center;\n                                flex-shrink: 0;\n                                border-radius: 16px;\n                                background: var(--AA-global-white-bg);\n                                color: var(--AA-gloabl-text-color);\n                                font-size: 12px;\n                                font-weight: 400;\n                                line-height: 16px;\n                            }\n                            a{\n                                overflow: hidden;\n                                color: var(--AA-gloabl-text-desc-color);\n                                text-align: center;\n                                text-overflow: ellipsis;\n                                font-size: 12px;\n                                font-weight: 400;\n                                line-height: 18px;\n                                opacity: 0.8;\n                            }\n                        }\n                    }\n                }\n            }\n            .form-feedback-info{\n                padding: 0;\n                background: transparent;\n                .dialog-ended-and-feedback{\n                    justify-content: flex-end;\n                    .feedback-wrapper {\n                        .feedback-actions-info {\n                            .left-sec-info {\n                                .icon_block{\n                                    display: none;\n                                }\n                                h1{\n                                    display: none;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .less-text{\n            &.hidden{\n                display: none;\n            }\n        }\n        .more-text{\n            &.hidden{\n                display: none;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
